/*
 * CancelTransaction messages
 *
 * This contains all the text for the CancelTransaction component
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'components.CancelTransactionMessage.label',
    defaultMessage: 'Payment already in progress',
  },
  started: {
    id: 'components.CancelTransactionMessage.started',
    defaultMessage:
      'Did you start the payment in another tab, window, or device?',
  },
  finish: {
    id: 'components.CancelTransactionMessage.finish',
    defaultMessage:
      'You can either finish your payment there or return to the checkout and start a new payment.',
  },
  return: {
    id: 'components.CancelTransactionMessage.return',
    defaultMessage: 'Return to checkout',
  },
});
